import * as fairTheme from './subpage_fairground/local-fairground.js';
import * as utils from './utils/utils.js';
import customNav from './utils/customNav.js';
import createTopBarLinks from './utils/createTopBarLinks.js';

// ---------------------------------

// AG ZONE THEME CONTROLLER
function themeController(sparkThemeConfig) {
  // ------------
  // Running subpages cleanup on homepage
  if ($('body').hasClass('homepage')) {
    utils.storage.setItem('subPage', false);
    utils.storage.setItem('subpageName', '');
  } else {
    // ------------
    // Control for subclases under saffire inner pages
    utils.addSubThemeToSaffirePages();
    // ------------
    // Running code for render subpages
    fairTheme.fairTheme(sparkThemeConfig);
  }

  customNav(sparkThemeConfig[0]);

  if (!utils.validateEntireSubpageTheme(sparkThemeConfig[0].baseThemeClass)) {
    $('.header .fairground-header-content').remove();
    $('.footer .fairground-footer').remove();
  }

  createTopBarLinks(sparkThemeConfig[0], topLinksConfig);

  setTimeout(() => {
    $('body').css('opacity', '1');
  }, 500);
}
export { themeController };
